/**
 * ポップオーバー表示
 * @param {Event} e
 */
function showTooltip(e, title, position) {
  var $current = $(e);
  var data_tooltip_pos = position;
  var $tooltip = $(
    `<span class="tooltip hide ${data_tooltip_pos} ">${title}</span>`
  );
  var tooltip_pos = {};
  var space = 4;
  //
  $("body").append($tooltip);
  //
  if (data_tooltip_pos === "top") {
    tooltip_pos.top = $current.offset().top - $tooltip.outerHeight() - space;
    tooltip_pos.left =
      $current.offset().left + $current.width() / 2 - $tooltip.outerWidth() / 2;
  } else if (data_tooltip_pos === "right") {
    tooltip_pos.top =
      $current.offset().top +
      $current.height() / 2 -
      $tooltip.outerHeight() / 2;
    tooltip_pos.left = $current.offset().left + $current.width() + space;
  } else if (data_tooltip_pos === "bottom") {
    tooltip_pos.top = $current.offset().top + $current.height() + space;
    tooltip_pos.left =
      $current.offset().left + $current.width() / 2 - $tooltip.outerWidth() / 2;
  } else if (data_tooltip_pos === "left") {
    tooltip_pos.top =
      $current.offset().top +
      $current.height() / 2 -
      $tooltip.outerHeight() / 2;
    tooltip_pos.left = $current.offset().left - $tooltip.outerWidth() - space;
  } else if (data_tooltip_pos === "topleft") {
    tooltip_pos.top = $current.offset().top - $tooltip.outerHeight() - space;
    tooltip_pos.left = $current.offset().left  + $current.width() - $tooltip.outerWidth();
  }
  $tooltip.css(tooltip_pos);
  $tooltip.fadeIn("fast", function () {
    $tooltip.removeClass("hide").addClass("show");
  });
}
/**
 * ポップオーバー非表示
 * @param {Event} e
 */
function hideTooltip() {
  var $tooltip = $("body > .tooltip");
  setTimeout(function () {
    $tooltip.fadeOut("fast", function () {
      $tooltip.remove();
    });
  }, 200);
}
export default {
  mounted(el, binding) {
    const { title, position } = binding.value;
    el.addEventListener("mouseover", () => {
      showTooltip(el, title, position);
    });
    el.addEventListener("mouseout", hideTooltip);
  },
  unmounted(el) {
    el = null;
  },
};
